export default __webpack_public_path__ + "static/media/ordersImg.faf429a9.svg";